import { eventSummary, formatAgo, formatWhen } from './SecurityDetail';
import { EVENT_GROUPS, eventGroup, formatLabel, groupLabel, humanizeText, projectLabel } from './securityLabels';

export function EventGroupGrid({ events = [], onSelectGroup, activeGroup }) {
  return (
    <div className="sec-group-grid">
      {EVENT_GROUPS.map((group) => {
        const items = events.filter((row) => eventGroup(row) === group.id);
        const selected = activeGroup === group.id;
        return (
          <button
            key={group.id}
            type="button"
            onClick={() => onSelectGroup?.(group.id)}
            className="sec-card sec-group"
            style={{
              background: selected ? group.tint : '#fff',
              borderColor: selected ? group.border : '#eef2f6',
              boxShadow: selected ? `0 0 0 1px ${group.accent}33` : undefined,
            }}
          >
            <p className="sec-group__title" style={{ color: group.accent }}>
              {formatLabel(group.title, group.tech)}
            </p>
            <p className="sec-group__count">{items.length}</p>
            <div className="sec-group__previews">
              {items.slice(0, 3).map((row) => (
                <p key={`${row.backend || 'ev'}-${row.id}`}>{eventSummary(row)}</p>
              ))}
              {items.length === 0 && <p>Nothing in this group yet.</p>}
            </div>
            <p className="sec-link">{items.length ? 'Open events →' : 'View group →'}</p>
          </button>
        );
      })}
    </div>
  );
}

export function GroupFilterChips({ active, onChange, allLabel = 'All', kinds }) {
  const groups = kinds ? EVENT_GROUPS.filter((group) => kinds.includes(group.id)) : EVENT_GROUPS;
  const chips = [{ id: '', title: allLabel, tech: null }, ...groups];
  return (
    <div className="sec-chips">
      {chips.map((chip) => {
        const id = chip.id || '';
        const selected = (active || '') === id;
        return (
          <button
            key={chip.id || 'all'}
            type="button"
            className={`sec-chip${selected ? ' is-active' : ''}`}
            onClick={() => onChange?.(id || null)}
          >
            {chip.tech ? formatLabel(chip.title, chip.tech) : chip.title}
          </button>
        );
      })}
    </div>
  );
}

export function EventRow({ row, onOpen }) {
  return (
    <button
      type="button"
      onClick={() => onOpen(row)}
      className={`sec-row${row.severity === 'critical' ? ' is-hot' : ''}`}
    >
      <div className="sec-row__top">
        <strong>{eventSummary(row)}</strong>
        <span className="sec-row__when" title={formatWhen(row.created_at)}>{formatAgo(row.created_at)}</span>
      </div>
      <p className="sec-row__meta">
        {groupLabel(eventGroup(row))}
        {row.backend ? ` · ${projectLabel(row.backend)}` : ''}
        {row.ip ? ` · ${row.ip}` : ''}
        {row.action ? ` · ${humanizeText(row.action)}` : ''}
      </p>
    </button>
  );
}
